import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { emailValidator } from 'src/app/theme/utils/app-validators';

@Component({
  selector: 'app-reservation-form',
  templateUrl: './reservation-form.component.html',
  styleUrls: ['./reservation-form.component.scss']
})
export class ReservationFormComponent implements OnInit {
  public form!: UntypedFormGroup;
  public hours = ['1:00am', '2:00am', '3:00am', '4:00am', '5:00am', '6:00am', '7:00am', '8:00am', '9:00am', '10:00am', '11:00am', '12:00am',
                  '1:00pm', '2:00pm', '3:00pm', '4:00pm', '5:00pm', '6:00pm', '7:00pm', '8:00pm', '9:00pm', '10:00pm', '11:00pm', '12:00pm'];
  public today = new Date();
  @Output() onFormSubmit: EventEmitter<any> = new EventEmitter();
  timeToCheckStart: any;
  timeToCheckEnd: any;
  dateToBookFor = new Date (new Date().toDateString());
  dateAddedBookingTime = new Date();
  bookingsPeriod = 60;

  constructor(public formBuilder: UntypedFormBuilder) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      fullName: [null, Validators.required],
      address: [null, Validators.required],
      city: [null, Validators.required],
      postCode: [null, Validators.required],
      phoneNumber: [null, Validators.required],
      email: [null, Validators.compose([Validators.required, emailValidator])],
      guests: [null, Validators.required],
      date: [null, Validators.required],
      // time: [null, Validators.required],
      inputTimeToCheckStart: [this.timeToCheckStart, Validators.compose([Validators.required])],
      inputTimeToCheckEnd: [{value: this.timeToCheckEnd, disabled: false}, Validators.compose([Validators.required])],
      message: null,
      dateAddedBookingTime: [new Date()],
    });

    console.log('kjb this.form.value', this.form.value);

    this.form.controls.inputTimeToCheckStart.valueChanges.subscribe((value: string) => {

      this.timeToCheckStart = value;

      let hours = Number(this.timeToCheckStart.split(':')[0]);
      let minutes = this.timeToCheckStart.split(':')[1];

      let cDate = new Date(this.dateToBookFor);
      cDate = new Date(cDate.getFullYear(), cDate.getMonth(), cDate.getDate(), hours, minutes, this.bookingsPeriod * 60);
      hours = cDate.getHours();
      const hoursAsString = hours < 10 ? '0' + hours : hours;
      minutes = cDate.getMinutes();
      const minutesAsString = minutes < 10 ? '0' + minutes : minutes;
      this.timeToCheckEnd = hoursAsString + ':' + minutesAsString;

      this.form.controls.inputTimeToCheckEnd.setValue(this.timeToCheckEnd);
      this.form.controls.dateAddedBookingTime.setValue(cDate);
      this.dateAddedBookingTime = cDate;

    });
  }

  public submit(){
    console.log(this.form.value);

    this.form.controls.fullName.setValue('Kelvin');
    this.form.controls.address.setValue('81 Southlands');
    this.form.controls.city.setValue('Blaina');
    this.form.controls.postCode.setValue('NP13 3JP');
    this.form.controls.phoneNumber.setValue('07973737097');
    this.form.controls.email.setValue('kelvin@admir.tv');
    this.form.controls.guests.setValue(2);
    this.form.controls.date.setValue(new Date());
    // this.form.controls.time.setValue(this.hours[12]);
    this.form.controls.message.setValue('Hello');


    if (this.form.valid){
      this.onFormSubmit.emit(this.form);
    }
  }

}
